// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';
import { BOTTOM_CONTROLS_HEIGHT, SUBTITLES_BOTTOM_SPACING } from "../../constants";
export var createSubtitlesWrapperCss = function createSubtitlesWrapperCss(_ref) {
  var fontSize = _ref.fontSize,
    lineHeight = _ref.lineHeight,
    textLength = _ref.textLength,
    visibleUi = _ref.visibleUi,
    isMd = _ref.isMd,
    isSm = _ref.isSm;
  var commonSubtitlesWrapperCss = /*#__PURE__*/css(["\n    font-family: Poppins, Arial, sans-serif;\n    font-size: ", "px;\n    line-height: ", "px;\n    max-width: calc(100% - 48px);\n    left: 50%;\n    transition: ", ";\n  "], fontSize, lineHeight, function (_ref2) {
    var theme = _ref2.theme;
    return theme.transition('transform', 300);
  });
  if (isMd) {
    return css(["\n      ", "\n      bottom: ", "px;\n      transform: translate(\n        -50%,\n        ", "\n      );\n    "], commonSubtitlesWrapperCss, SUBTITLES_BOTTOM_SPACING.md, visibleUi ? "-".concat(BOTTOM_CONTROLS_HEIGHT.md, "px") : 0);
  }
  if (isSm) {
    return css(["\n      ", "\n      min-width: ", ";\n      bottom: ", "px;\n      transform: translate(\n        -50%,\n        ", "\n      );\n    "], commonSubtitlesWrapperCss, textLength >= 35 ? '528px' : 'auto', SUBTITLES_BOTTOM_SPACING.sm, visibleUi ? "-".concat(BOTTOM_CONTROLS_HEIGHT.sm, "px") : 0);
  }
  return css(["\n    ", "\n    width: ", ";\n    bottom: ", "px;\n    transform: translateX(-50%);\n  "], commonSubtitlesWrapperCss, textLength >= 20 ? 'calc(100% - 40px)' : 'auto', SUBTITLES_BOTTOM_SPACING.xxs);
};